import parseISO from "date-fns/parseISO";
import { client as request } from "./request";
import { FolderEntry, Breadcrumb } from "@/models/file";

export interface Folder extends FolderEntry {}

export interface Report extends FolderEntry {
  pdf: string;
  scenes: ReportScene[];
}

export interface ReportScene {
  reportSceneId?: any;
  state: string;
  date?: Date;
  note: string;
  imageURL: string;
  companyId: string;
}

export const newScene = () => ({
  state: "",
  note: "",
  imageURL: "",
  companyId: "0"
});

export const newReport = (parentFolderId: any = "0"): Report => ({
  parentFolderId,
  kind: "file",
  name: "",
  image: "",
  pdf: "",
  updated: new Date(),
  startDate: "",
  endDate: "",
  scenes: [newScene()]
});

const ReportScene = (data: any) => ({
  ...data,
  date: parseISO(data.date)
});

export const Report = (data: any) => ({
  ...data,
  updated: parseISO(data.updated),
  scenes: data.scenes ? data.scenes.map(ReportScene) : data.scenes
});

export interface ResponseEntries {
  entries: (Folder | Report)[];
  path: Breadcrumb[];
}

export async function getEntriesInCurrentFolder(
  projectId: any,
  currentFolderId: any
) {
  const res = await request.get("get_report_entries.php", {
    projectId,
    currentFolderId
  });
  return {
    ...res,
    entries: (res.entries || []).map(Report)
  } as ResponseEntries;
}

export async function saveReportEntry(data: FormData): Promise<number> {
  const res = await request.post("save_report_entry.php", data);
  return res.reportEntryId;
}

export async function deleteReportEntry(id: any) {
  const data = new FormData();
  data.append("id", id);
  await request.post("delete_report_entry.php", data);
}

export async function readReportEntry(entryId: any) {
  const data = new FormData();
  data.append("entryId", entryId);
  await request.post("read_report_entry.php", data);
}
